import { Http } from "../Http";
export class PasswordresetApi {
   public static savepasswordreset(input: any) {

        var obj=JSON.stringify(input);
        var url="api/resetpassword";
 
       
        const resultMethod = Http.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
          
            return res;
          }).catch((e: any) => {
         
            return e.response;
          });
        return resultMethod;
}

public static getpasswordbyactcode(input: any) {
    if (input === "") {
      return { data: [] };
    }
  
    var url = "/api/getactcode/" + input;
    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;
  }
}